export default __webpack_public_path__ + "static/media/placeholder_business01-es-mobile.a51bcb07.png";